module.exports = __webpack_public_path__ + "static/media/Deep_Web.7d38379b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lives/Deep_Web.png
// module id = 305
// module chunks = 0